import { AddressFormValue } from '../../types/document-form-data';

export function addressFormValueToText(address: AddressFormValue | null): string | null {
  if (!address) return null;
  const text = (v: string | null): string => v?.trim() ?? '';
  const lines = [
    [address.salutation, address.name1, address.name2, address.name3]
      .map(text)
      .filter(Boolean)
      .join(' '),
    text(address.street),
    [text(address.countryCode), text(address.postCode), text(address.city)]
      .filter(Boolean)
      .join(' '),
    text(address.mail1),
  ].filter(Boolean);
  return lines.length ? lines.join('\n') : null;
}
